import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { isAuthenticated } from './services/studentportalapis';
import Login from "./features/login/Login";
import Dashboard from "./features/dashboard/Dashboard";
import './styles/global.css';
import Registration, { loader as collegeDetailsLoader } from "./features/registration/registration";
import LandingPage from "./features/landing/LandingPage";
import ForgotPassword from "./features/ForgotPassword/ForgotPassword";
import Admin from "./features/admin/Admin";
import LinkedIn from "./features/linkedIn_follow/LinkedIn";
import UserProfile from "./features/userAcc/UserAccount";
import FAQ from "./features/faq/Faq";
import ResetPassword from "./features/password/ResetPassword";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminDashboard from "./features/admin/Admin";
import RegistrationConfirmation from "./features/confirmation/Confirmation";
import NotFound from "./features/notFound/notFound";
import AdminCourseControl from "./features/admin/adminCourseControl/AdminCourseControl";
import AdminApprovedEmailControl from "./features/admin/adminApprovedEmailControl/AdminApprovedEmailControl";
import KnowAbout from "./features/dashboardPages/KnowAbout";
import CollegeCollab from "./features/dashboardPages/CollegeCollab";
import KnowYourProgramCoordinators from "./features/dashboardPages/KnowYourProgramCoordinators";
import { useDispatch, useSelector } from "react-redux";
import { resetLoggedInState, setLoggedInState, setUserRole, } from "./features/login/loginSlice";
import { fetchStudentData } from './services/studentportalapis';
import LearningTrack from "./features/dashboardPages/LearningTrack"
import CollegeManagement from "./features/admin/collegeManagement/CollegeManagement";
import MyInternship from "./features/dashboardPages/MyInternshipPlan"
import MyTrack from "./features/dashboardPages/MyLearningTrack"
import KnowMore from "./features/dashboardPages/KnowMore";
import AddProject from "./features/admin/addProject/AddProject";

function App() {
  const loginInfo = useSelector((store) => store.loggedInState);
  let authStatus = loginInfo.loggedInState;
  let userRole = loginInfo.userRole;
  const dispatch = useDispatch();
  useEffect(() => {
    const checkAuth = async () => {
      const responseData = await isAuthenticated();
      if(responseData.status === "true"){
        dispatch(setLoggedInState(true));
        dispatch(setUserRole(responseData.role));
        const storedStudentData = localStorage.getItem('student-details');
        if (storedStudentData === "" || storedStudentData === null) {
          const data = await fetchStudentData(); 
          localStorage.setItem('student-details', JSON.stringify(data));
        }
      }else{
        dispatch(resetLoggedInState);
      }
    };
    checkAuth();
  }, []);

  // if (authStatus && userRole !== "") {
  //   return <div>Loading...</div>; // Show loading state
  // }

  const router = createBrowserRouter([
    {
      path: "/",
      // element: authStatus ? <Navigate to="/dashboard" /> : <LandingPage />,
      element:
        userRole === "student" ? (
          <Navigate to="/dashboard" />
        ) : userRole === "admin" ? (
          <Navigate to="/admin" />
        ) : (
          <LandingPage />
        ),
    },
    {
      path: "/login",
      // element: authStatus ? <Navigate to="/dashboard" /> : <Login />,
      element:
        userRole === "student" ? (
          <Navigate to="/dashboard" />
        ) : userRole === "admin" ? (
          <Navigate to="/admin" />
        ) : (
          <Login />
        ),
    },
    {
      path: "/forgot-password",
      element: <ForgotPassword />,
    },
    {
      path: "/linkedIn",
      element: <LinkedIn />,
    },
    {
      path: "/confirmation",
      element: <RegistrationConfirmation />,
    },
    {
      path: "/dashboard",
      element: 
      // (
      //   <ProtectedRoute>
          <Dashboard />
      //   </ProtectedRoute>
      // )
      ,
    },
    {
      path: "/register",
      // element: authStatus ? <Navigate to="/dashboard" /> : <Registration />,
      element:
        userRole === "student" ? (
          <Navigate to="/dashboard" />
        ) : userRole === "admin" ? (
          <Navigate to="/admin" />
        ) : (
          <Registration />
        ),
      loader: collegeDetailsLoader,
    },
    {
      path: "/reset",
      element: <ResetPassword />,
    },
    {
      path: "/faq",
      element: <FAQ />,
    },
    {
      path: "/userAcc",
      element: 
      // (
      //   <ProtectedRoute>
          <UserProfile />
      //   </ProtectedRoute>
      // )
      ,
    },
    {
      path: "/admin",
      // element: <Admin />,
      element: 
      // (
      //   <ProtectedRoute>
          <Admin />
      //   </ProtectedRoute>
      // )
      ,
    },
    {
      path:"/know-your-program-coordinators",
      element:<KnowYourProgramCoordinators/>
    },
    {
      path:"/admin-course-control",
      element:<AdminCourseControl/>
    },
    {
      path:"/admin-approved-email-control",
      element:<AdminApprovedEmailControl/>
    },
    {
      path: "*",
      element: <NotFound />,
    },
    {
      path: "/KnowAbout",
      element: <KnowAbout/>,
    },
    {
      path: "/CollegeCollab",
      element: <CollegeCollab/>,
    },
    
    {
      path: "/Learning-Track",
      element: <LearningTrack/>,
    },
    {
      path: "/College-Management",
      element: <CollegeManagement/>,
    },

    {
      path: "/My-Internship-Plan",
      element: <MyInternship/>,
    },

    {
      path: "/track/:courseName/:id",
      element: <MyTrack/>,
    },

    {
      path: "/knowMore/:trackName/:id",
      element: <KnowMore/>,
    },

    {
      path: "/addProject",
      element: <AddProject/>,
    },
    


  ]);

  return <RouterProvider router={router} />;
}

export default App;
